export default "__VITE_ASSET__DaOT9uEK__"